// extracted by mini-css-extract-plugin
export default {"tip":"FieldScore_tip__pAsE7"};